export default __webpack_public_path__ + "static/media/icn-linkedin.97a0b42b.svg";